import { render } from "./phone-number.vue?vue&type=template&id=1bae5b8f&scoped=true"
import script from "./phone-number.vue?vue&type=script&lang=js"
export * from "./phone-number.vue?vue&type=script&lang=js"

import "./phone-number.vue?vue&type=style&index=0&id=1bae5b8f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bae5b8f"]])

export default __exports__